import React, {useEffect, useState} from 'react'
import _ from "lodash"
import classnames from "classnames"
import {useSelector} from 'react-redux'
//************************************//
import {trans} from "@utils"
import InputContainer from "@src/components/helpers/InputContainer"
//************************************//

const GlobalListTypeFieldsSelect = props => {
//************************************//
  const {useForm, name = "", globalListUuid = null, rules = {}, hideFormGroup = false, isMulti = false, isClearable = true, filterType = ''} = props
  const {control, errors, watch, register, getValues, setValue, setError, clearErrors } = useForm
//************************************//
  const globalLists = useSelector(store => store.resources.data.global_list)
//************************************//
  const staticOptions = [
    {label: trans('resources.inputs.itemId'), value: "item_id", field_type: "text"},
    {label: trans('resources.inputs.displayName'), value: "display_name", field_type: "text"}
  ]
//************************************//
  const [defaultValue, setDefaultValue] = useState(props.defaultValue)
  const [loading, setLoading] = useState(false)
  const [globalListFieldOptions, setGlobalListFieldOptions] = useState(staticOptions)
//************************************//
  const setFieldValue = (val, items) => {
    if (val && _.find(items, x => x.value === val)) {
      setValue(name, _.find(items, x => x.value === val))
    } else {
      setValue(name, '')
    }
  }
//************************************//
  const getData = async (values, SetErrorIfFieldNotExist = false) => {
    if (_.isObject(globalListUuid)) {
      // setLoading(true)
      let optionsArr = []
      const data = _.find(globalLists, globalList => globalList.uuid === globalListUuid.value)
      // const data = await _getAsyncGlobalList(globalListUuid)
      let fields = data?.fields
      let filteredStaticOptions = staticOptions
      if (_.size(filterType) > 0) {
        fields = _.filter(fields, x => x.field_type === filterType)
        filteredStaticOptions = _.filter(filteredStaticOptions, x => x.field_type === filterType)
      }
      optionsArr = [
        ...optionsArr,
        ..._.map(fields, x => ({label: x.name, value: x.key, field_type: x.field_type}))
      ]
      const finalOptions = [...filteredStaticOptions, ...optionsArr]
      setGlobalListFieldOptions(finalOptions)
      if (isMulti) {
        if (_.size(values)) {
          const selectedItems = []
          let errorCondition = false
          _.forEach(values, selected => {
            const item = _.find(finalOptions, x => x.value === selected.value)
            if (item) {
              selectedItems.push(item)
            } else if (SetErrorIfFieldNotExist) {
              errorCondition = true
              setError(name, {type: 'custom', message: trans('resources.validations.fieldError')})
            }
          })
          setValue(name, selectedItems)
          if (!errorCondition) {
            clearErrors(name)
          }
        }
      } else {
        if (_.isObject(values)) {
          let errorCondition = false
            const item = _.find(finalOptions, x => x.value === values.value)
            if (item) {
              setValue(name, item)
            } else if (SetErrorIfFieldNotExist) {
              errorCondition = true
              setError(name, {type: 'custom', message: trans('resources.validations.fieldError')})
            }
          if (!errorCondition) {
            clearErrors(name)
          }
        }
      }
      if (defaultValue !== null) {
        setDefaultValue(null)
      }
      // setLoading(false)
    }
  }
//************************************//
  useEffect(() => {
    if (isMulti) {
      if (_.isArray(defaultValue)) {
        getData(_.map(defaultValue, value => ({ label: '', value })), true)
      } else {
        getData(getValues(name))
      }
    } else {
      if (_.isString(defaultValue) && _.size(defaultValue) > 0) {
        getData({ label: '', value: defaultValue }, true)
      } else {
        getData(getValues(name))
      }
    }

  }, [globalListUuid])
//************************************//
  return (
    <>
      <InputContainer
        isLoading={loading}
        isDisabled={loading}
        control={control}
        isMulti={isMulti}
        isClearable={isClearable}
        type='select'
        options={globalListFieldOptions}
        name={name}
        defaultValue={''}
        classNamePrefix={'select'}
        className={classnames('react-select', {'is-invalid':_.get(errors, name)})}
        rules={rules}
      />
      {_.get(errors, name) && <span className={'text-danger'}>{_.get(errors, `${name}.message`)}</span>}
    </>
  )
}

GlobalListTypeFieldsSelect.propTypes = {

}

export default GlobalListTypeFieldsSelect
